import React, { FunctionComponent } from 'react';
import { isArray } from 'lodash';
import { useTranslate } from 'react-admin';
import { RangeFieldProps } from './type';

const RangeField: FunctionComponent<RangeFieldProps> = (props) => {
  const t = useTranslate();
  const { details } = props;

  const before =
    details.args !== undefined && isArray(details.args.before)
      ? details.args.before.join(' - ')
      : t('history.company.field_updated.no_tags');
  const after =
    details.args !== undefined && isArray(details.args.after)
      ? details.args.after.join(' - ')
      : t('history.company.field_updated.no_tags');

  return (
    <span>{t(`${details.translation_key}.details`, { before, after })}</span>
  );
};

export default RangeField;
